const article = {
    slug: "cecilie-bahnsen",
    category: "BRAND BUYBACK",
    listTitle: "CECILIE BAHNSEN（セシリー バンセン）買取",
    listDescription:
      "可憐な見た目だけでなく、クチュール技法、立体構造、シーズン背景、希少性まで確認して査定するEnclopediaのブランド別買取ページ。",
  
    seo: {
      title:
        "セシリーバンセン高価買取｜CECILIE BAHNSENを背景まで査定",
      description:
        "CECILIE BAHNSEN（セシリー バンセン）の買取ならEnclopediaへ。ドレス、ワンピース、ASICS、THE NORTH FACE、刺繍やジャカードをシーズン背景まで査定。LINE事前査定から送料無料の宅配買取へご案内します。",
      keyword:
        "CECILIE BAHNSEN 買取,セシリーバンセン 買取,セシリー バンセン 買取,セシリーバンセン 高価買取,CECILIE BAHNSEN 高価買取,セシリーバンセン 宅配買取,CECILIE BAHNSEN ワンピース 買取,セシリーバンセン ドレス 買取,CECILIE BAHNSEN ASICS 買取,セシリーバンセン アシックス 買取,CECILIE BAHNSEN THE NORTH FACE 買取,セシリーバンセン ノースフェイス 買取,デザイナーズブランド 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/cecilie-bahnsen",
    },
  
    hero: {
      label: "CECILIE BAHNSEN BUYBACK",
      number: "01 / BUYBACK",
      titleLines: [
        "CECILIE BAHNSEN買取。",
        "日常のためのクチュールまで査定します。",
      ],
      body:
        "Enclopediaは、CECILIE BAHNSENを「ボリュームのある可愛いワンピース」という理由だけで判断しません。\n独自に開発されたテキスタイル、身体の周囲に余白をつくる構造、クチュールの手仕事を日常着へ変換する設計まで確認します。\nシーズン背景、コレクション性、希少性、現在の需要を踏まえ、一着ずつ査定します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "everyday couture",
        "sculptural volume",
        "bespoke textiles",
        "archive valuation",
      ],
      visualLabel: "EVERYDAY COUTURE",
      visualTitle: [
        "ロマンティックな見た目ではなく、",
        "それを日常で機能させる構造を見る。",
      ],
      image:
        "media/archive_fashion/buyback-cecilie-bahnsen.png",
      imageAlt:
        "CECILIE BAHNSEN セシリーバンセンのドレスやワンピースを背景まで査定する買取ページ",
    },
  
    thesis: {
      text:
        "クチュールの手仕事を特別な日のために保存するのではなく、歩き、重ね、繰り返し着られる日常へ移す。",
      keywords: ["couture", "function", "movement"],
    },
  
    intro: {
      label: "02 / DESIGNER & BRAND",
      titleLines: [
        "CECILIE BAHNSENは、",
        "可憐なドレスではなく、日常に耐えるクチュール。",
      ],
      body:
        "デザイナーのCecilie Bahnsenは、コペンハーゲン近郊で育ち、デンマークのデザインスクールとロンドンのRoyal College of Artで学びました。John Gallianoではプリントデザインやファーストラインに携わり、Erdemなどで経験を積んだ後、2015年に自身のブランドを設立。2016年にDANSK Design Talent Awardを受賞し、2017年にはLVMH Prizeのファイナリストに選出されました。\n\nブランドの特徴として語られるのは、パフスリーブ、ティアードスカート、リボン、花柄、透けるオーガンザ、膨らんだドレスです。しかし、CECILIE BAHNSENの本質は装飾の多さだけではありません。\n\nフランス的なクチュールの技術と、スカンジナビアの簡潔さ、機能性、気負わなさを組み合わせる。立体的なドレスをスニーカーやデニム、テクニカルアウターと共存させ、特別な日の服を日常の動作へ戻していきます。\n\nEnclopediaは、その大きなシルエットを身体を飾るための過剰なボリュームではなく、身体を締め付けず、動きによって服を完成させるための余白だと捉えます。",
    },
  
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つのCECILIE BAHNSEN査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "独自のテキスタイルを見る",
          text:
            "フィルクーペ、マトラッセ、ジャカード、オーガンザ、刺繍、キルティング、スモッキングなど、柄だけでなく、生地そのものを立体化する技法まで確認します。",
        },
        {
          number: "02",
          title: "身体とボリュームの関係を見る",
          text:
            "袖の膨らみ、ギャザー、切り替え、ティアード、裾の張り、背面のボリュームなど、着用時にどのような空間と動きが生まれるかを見ます。",
        },
        {
          number: "03",
          title: "シーズンと希少性を見る",
          text:
            "ランウェイ登場品、ブランドを象徴するドレス、初期作品、Encore、Made to Order、限定コラボレーションを、流通量や再入手難度まで含めて査定します。",
        },
      ],
    },
  
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "CECILIE BAHNSENの主要アイテムを、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "ワンピース・ドレス",
          text:
            "パフスリーブ、ティアード、リボン、カットアウト、立体的な裾など、ブランドのシルエットとテキスタイルが凝縮された主要カテゴリーです。",
        },
        {
          tag: "ITEM 02",
          title: "ブラウス・シャツ・トップス",
          text:
            "ボリュームスリーブ、ペプラム、オープンバック、スモッキング、花柄刺繍を用いたトップスも積極的に査定します。",
        },
        {
          tag: "ITEM 03",
          title: "スカート",
          text:
            "ティアードスカート、キルティングスカート、アシンメトリー、立体的なフレアなど、単品でもブランド性の強いモデルを確認します。",
        },
        {
          tag: "ITEM 04",
          title: "コート・ジャケット・アウター",
          text:
            "クチュール的な生地と、テーラリング、ミリタリー、アウトドアの構造を組み合わせたアウターを丁寧に評価します。",
        },
        {
          tag: "ITEM 05",
          title: "ニット・デニム・トラウザーズ",
          text:
            "ドレス以外の日常的なカテゴリーも対象です。装飾、生地、レイヤード設計、シーズンとの関係を踏まえて査定します。",
        },
        {
          tag: "ITEM 06",
          title: "シューズ・バッグ・アクセサリー",
          text:
            "リボンや花の装飾を用いたシューズ、バッグ、ヴェールなど、ブランドの造形を小物へ展開したアイテムもご相談ください。",
        },
        {
          tag: "ITEM 07",
          title: "Encore・Made to Order・初期アーカイブ",
          text:
            "過去シーズンの希少生地を再利用したEncore、コペンハーゲンのアトリエで制作されるMade to Order、初期作品も個別に価値を確認します。",
        },
        {
          tag: "ITEM 08",
          title: "ASICS・THE NORTH FACE等のコラボレーション",
          text:
            "ASICS、THE NORTH FACE、Alpha Industriesなどとの協業品も対象です。メインラインや量産型コラボとは流通量と市場が異なるため、個別に査定します。",
        },
      ],
    },
  
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "CECILIE BAHNSENのアイテム。",
      ],
      intro:
        "査定額はシーズン、モデル、状態、市場需要によって変動します。Enclopediaでは、見た目の華やかさだけでなく、テキスタイルと構造の完成度を確認します。",
      items: [
        {
          index: "01",
          title: "ブランドを象徴するドレス・ワンピース",
          text:
            "立体的な袖や裾、独自の生地、複雑な切り替えが一体となった代表的なドレスは、モデルと現在の需要を確認して評価します。",
        },
        {
          index: "02",
          title: "希少なフィルクーペ・マトラッセ・刺繍作品",
          text:
            "生地の開発に高度な技術と工程を要するアイテムは、柄、織り、立体感、保存状態を含めて丁寧に見ます。",
        },
        {
          index: "03",
          title: "ランウェイ登場品・Made to Order",
          text:
            "ランウェイを象徴するピース、アトリエで制作された限定的な作品、アーカイブから復刻された服は、来歴と希少性を確認します。",
        },
        {
          index: "04",
          title: "需要の高い限定コラボレーション",
          text:
            "ASICSのシューズやTHE NORTH FACEのアウターなど、機能性とブランドの装飾表現が明確に融合した協業品を個別評価します。",
        },
      ],
    },
  
    quote: {
      textLines: [
        "特別な日のために、日常から切り離された服ではない。",
        "特別な服を、日常の身体へ返す。",
      ],
    },
  
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定では、",
        "見落とされやすいCECILIE BAHNSENの価値。",
      ],
      intro:
        "CECILIE BAHNSENの価値は、ワンピースであることや、ボリュームが大きいことだけでは判断できません。",
      items: [
        {
          index: "01",
          title: "“ガーリーな服”で終わらせない",
          text:
            "リボンや花、パフスリーブの内側にある、クチュール技法、素材開発、身体を解放する構造まで確認します。",
        },
        {
          index: "02",
          title: "ボリュームをサイズ感だけで判断しない",
          text:
            "大きく見えるシルエットも、肩、胸元、ウエスト、背面、裾へどのように分量を配置しているかによって価値が異なります。",
        },
        {
          index: "03",
          title: "同じ花柄として一括りにしない",
          text:
            "プリント、刺繍、織り、フィルクーペ、アップリケでは、製造技法と立体感が異なります。素材ごとの工程と希少性を確認します。",
        },
        {
          index: "04",
          title: "コラボレーションを一律に見ない",
          text:
            "アトリエで手作業された限定品、一般流通モデル、大量生産された協業品では市場が異なります。ブランド名だけで同じ評価にはしません。",
        },
      ],
    },
  
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "CECILIE BAHNSENの宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "全体写真、ブランドタグ、品質表示タグ、品番、サイズ、生地のアップ、状態が分かる写真をお送りください。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "事前査定後、本査定をご希望の場合は申込フォームへ。宅配キットの要否も選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。立体的な袖や裾を強く圧縮せず、刺繍や装飾が引っ掛からないように梱包してください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後、状態、真贋、シーズン、テキスタイル、希少性、市場性を確認。金額にご納得いただければ、ご指定口座へ入金します。",
        },
      ],
    },
  
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "テキスタイルまで確認する宅配買取。",
      ],
      intro:
        "商品名やシーズンが分からない場合も、LINEで写真を確認してから宅配買取へ進めます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "写真とタグ情報から事前確認できるため、査定対象か分からない服やシューズも相談できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合は、そのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
  
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "CECILIE BAHNSEN買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "CECILIE BAHNSEN（セシリー バンセン）はどのようなブランドですか？",
          answer:
            "デンマークのデザイナーCecilie Bahnsenが2015年に設立したブランドです。クチュールの手仕事とスカンジナビアの機能性を組み合わせ、立体的なドレスや独自のテキスタイルを日常着として提案しています。",
        },
        {
          question:
            "どのようなセシリーバンセンが高価買取につながりやすいですか？",
          answer:
            "代表的なドレス、フィルクーペやマトラッセを用いた作品、ランウェイ登場品、Made to Order、状態の良い限定コラボレーションなどは評価につながりやすい傾向があります。",
        },
        {
          question:
            "CECILIE BAHNSENのワンピース以外も買取できますか？",
          answer:
            "可能です。ブラウス、トップス、スカート、パンツ、ニット、コート、ジャケット、バッグ、シューズ、アクセサリーまで幅広く査定します。",
        },
        {
          question:
            "CECILIE BAHNSENとASICSのシューズも買取できますか？",
          answer:
            "査定可能です。モデル、サイズ、カラー、装飾の欠損、ソールの減り、箱や替え紐などの付属品、現在の需要を確認します。",
        },
        {
          question:
            "THE NORTH FACEとのコラボレーションも買取できますか？",
          answer:
            "査定可能です。ジャケット、ダウン、シューズ、バッグなどを、品番、状態、付属品、流通量、市場需要に基づいて確認します。",
        },
        {
          question:
            "古いシーズンのCECILIE BAHNSENも査定できますか？",
          answer:
            "査定可能です。年代だけで判断せず、初期作品としての重要性、テキスタイル、シルエット、希少性、現在の需要、保存状態を確認します。",
        },
        {
          question:
            "刺繍のほつれや生地の引っ掛けがあっても買取できますか？",
          answer:
            "状態によっては査定可能です。刺繍糸の浮き、フィルクーペの毛羽立ち、オーガンザの傷、シミ、型崩れなどがある場合は、LINE査定時に該当箇所の写真をお送りください。",
        },
        {
          question:
            "シーズンや正式な商品名が分からなくても査定できますか？",
          answer:
            "可能です。全体写真、ブランドタグ、品質表示タグ、品番、生地や装飾のアップから、確認できる範囲でモデルとシーズンを調査します。",
        },
      ],
    },
  
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "CECILIE BAHNSENの価値をご相談ください。",
      ],
      body:
        "大きなシルエットや花柄という見た目だけでなく、その服にどのような技法、構造、シーズンの意味が残されているのかまで確認します。\n写真による事前査定から、CECILIE BAHNSENを理解した宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };
  
  export default article;